import React, { useState } from "react";
import {
  handleAzimuthChange,
  handleCapacityType,
  handleInputChange,
} from "../DSFunction";
import { updateDesignParameter } from "../../../../Features/designParameter";
import { useDispatch, useSelector } from "react-redux";

export default function CapacityOption({handleKeyPress}) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);
  const [error, setError] = useState(false);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];

  return (
    <>
      <div className="formWithLabel">
        <div className="parameter">
          <label>Custom Capacity(KW)</label>
          <div
            className="capacityParameter"
            onClick={() =>
              dispatch(
                updateDesignParameter({
                  customCapacityCheck: !designParameter.customCapacityCheck,
                })
              )
            }
          >
            <span
              style={
                !designParameter.customCapacityCheck
                  ? { backgroundColor: "#FF7C1B" }
                  : {}
              }
            >
              Auto
            </span>
            <span
              style={
                designParameter.customCapacityCheck
                  ? { backgroundColor: "#FF7C1B" }
                  : {}
              }
            >
              Custom
            </span>
          </div>
        </div>
        <div className="customInput">
          <input
            type="text"
            value={roofDetail.customCapacity}
            name="customCapacity"
            disabled={designParameter.customCapacityCheck ? false : true}
            style={
              designParameter.customCapacityCheck
                ? {}
                : { backgroundColor: "#E9ECEF" }
            }
            onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
            onKeyPress={(e) => handleKeyPress(e)}
          ></input>
        </div>
      </div>
      <div className="selectionButton">
        <button
          onClick={() => handleCapacityType("Auto", dispatch, roofIndex)}
          style={{
            backgroundColor:
              roofDetail.customCapacityType === "Auto"
                ? "#ff7f1e"
                : "#072a4066",
          }}
        >
          Auto Settings
        </button>
        <button
          onClick={() => handleCapacityType("Custom", dispatch, roofIndex)}
          style={{
            backgroundColor:
              roofDetail.customCapacityType === "Custom"
                ? "#ff7f1e"
                : "#072a4066",
          }}
        >
          Custom Settings
        </button>
      </div>

      <div className="formWithLabel">
        <label>Azimuth Angle (Degrees)</label>
        <input
          type="text"
          value={roofDetail.azimuth}
          name="azimuth"
          onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
          onKeyPress={(e) => handleKeyPress(e)}
          disabled={roofDetail.customCapacityType === "Custom" ? false : true}
          style={
            roofDetail.customCapacityType === "Custom"
              ? {}
              : { backgroundColor: "#E9ECEF" }
          }
        ></input>
        <div className="azimuthChange">
          <i
            className="bi bi-caret-up-fill"
            onClick={() =>
              handleAzimuthChange(
                "up",
                roofInfo,
                dispatch,
                gridInfo,
                setError,
                roofDetail,
                designParameter,
                quantityInfo
              )
            }
          ></i>
          <i
            className="bi bi-caret-down-fill"
            onClick={() =>
              handleAzimuthChange(
                "down",
                roofInfo,
                dispatch,
                gridInfo,
                setError,
                roofDetail,
                designParameter,
                quantityInfo
              )
            }
          ></i>
        </div>
        {error && (
          <span className="azimuthError">Azimuth is between 0 and 360</span>
        )}
      </div>
      {!(roofDetail.mountingStructure === "Double Carport") && (
        <div className="formWithLabel">
          <label>Row Distance</label>
          <input
            type="text"
            value={roofDetail.rowDistance}
            name="rowDistance"
            onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
            onKeyPress={(e) => handleKeyPress(e)}
            disabled={roofDetail.customCapacityType === "Custom" ? false : true}
            style={
              roofDetail.customCapacityType === "Custom"
                ? {}
                : { backgroundColor: "#E9ECEF" }
            }
          ></input>
          <span className="unitValue">
            (
            {gridInfo.unit === "ft"
              ? (roofDetail.rowDistance * 0.00328084).toFixed(2)
              : (roofDetail.rowDistance * 0.001).toFixed(2)}
            {gridInfo.unit})
          </span>
        </div>
      )}
      {roofDetail.mountingStructure === "Double Carport" && (
        <div className="formWithLabel">
          <label>Road Spacing({gridInfo.unit})</label>
          <input
            type="text"
            value={roofDetail.roadSpace}
            name="roadSpace"
            onChange={(e) => handleInputChange(e, dispatch, roofIndex)}
            onKeyPress={(e) => handleKeyPress(e)}
            disabled={roofDetail.customCapacityType === "Custom" ? false : true}
            style={
              roofDetail.customCapacityType === "Custom"
                ? {}
                : { backgroundColor: "#E9ECEF" }
            }
          ></input>
        </div>
      )}
    </>
  );
}
